<template>
    <modal :id="utils.randomId({prefix: 'settings'})"
           size="lg"
           :show="!!path"
           v-if="path"
           @close="close()">
        <template #title>
            Learning Path Settings
        </template>

        <div class="form-group">
            <label for="path-name">Path Name</label>
            <input type="text" id="path-name" class="form-control form-control-lg"
                   v-model="path.name"
                   @change="update">
        </div>

        <div class="form-group" v-if="is_admin && tenants?.length">
            <label for="path-tenant">Tenant</label>
            <select class="form-control form-control-lg"
                    id="path-tenant"
                    v-model="tenant_id"
                    @change="update">
                <option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
                    {{ tenant.name }}
                </option>
            </select>
        </div>

        <div class="form-group" v-if="is_admin">
            <label for="path-editable-by">Editable By</label>
            <select class="form-control form-control-lg"
                    id="path-editable-by"
                    v-model="path.meta.editable_by"
                    @change="update">
                <option value="admin">Admin</option>
                <option value="teacher">Teacher</option>
            </select>
        </div>

        <div class="form-group">
            <label for="path-description">Description</label>
            <textarea type="text"
                      rows="4"
                      id="path-description"
                      class="form-control form-control-lg"
                      v-model="path.meta.description"
                      @change="update"></textarea>
        </div>

        <div class="form-group">
            <label for="path-preview">Preview Image</label>
            <file-uploader v-model="path.meta.image"
                           @change="update"></file-uploader>
        </div>

        <div class="form-group">
            <label for="path-name">Sponsor Name</label>
            <input type="text" id="sponsor-name" class="form-control form-control-lg"
                   v-model="path.meta.sponsor_name"
                   @change="update">
        </div>

        <div class="form-group">
            <label for="path-name">Sponsor URL</label>
            <input type="text" id="sponsor-url" class="form-control form-control-lg"
                   v-model="path.meta.sponsor_url"
                   @change="update">
        </div>

        <div class="form-group">
            <label for="path-preview">Sponsor Logo</label>
            <file-uploader v-model="path.meta.sponsor_logo"
                           @change="update"></file-uploader>
        </div>

        <div class="form-group">
            <label for="path-preview">Standard Alignment Guidelines</label>
            <file-uploader v-model="path.meta.guidelines"
                           @change="update"></file-uploader>
        </div>

        <template #footer>
            <state-button
                v-if="path.owner !== 'shadow'"
                type="button"
                class="btn btn-danger mr-auto"
                :state="is_deleting ? 'busy' : ''"
                :disabled="is_deleting"
                @click="remove()">Remove</state-button>
            <button type="button"
                    class="btn btn-dark"
                    :disabled="is_deleting"
                    @click="close()">Close</button>
        </template>

    </modal>
</template>

<script>
import API from "@/API";
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";
import StateButton from "@/Components/Common/StateButton";
import FileUploader from "@/Components/Common/FileUploader";

export default {
    name: "LearningPathSettingsModal",
    components: {FileUploader, Modal, StateButton},
    props: ['path', 'tenants'],
    emits: ['deleted', 'close'],
    mixins: [utils],

    data(){
        return {
            tenant_id: null,
            enabled: false,
            is_deleting: false,
            updateDebounced: _.debounce((...args) => this.update(), 500),
        }
    },


    computed: {

    },

    methods: {

        current_tenant_tags(){
            return this.tags('App\\Models\\Tenant');
        },

        current_tagged_tenant(){
            const tags = this.current_tenant_tags();
            console.log({tags});
            return (!tags || typeof tags[0] === 'undefined') ? null : tags[0]?.tagger;
        },

        tags(type = null){
            return type ? this.path?.tags?.filter(tag => tag.tagger_type === type) : this.path.tags;
        },

        async update(){
            const path = await API.learning_paths
                .updateSettings(this.path.id, {
                    name: this.path?.name,
                    meta: this.path?.meta,
                    tenant_id: this.tenant_id,
                });

            this.path.name = path.name;
            this.path.meta = path.meta;
            this.path.tags = path.tags;

            const tenant = this.current_tagged_tenant();
            this.tenant_id = tenant?.id;
        },

        async remove(){
            if( !confirm('Are you sure to delete this learning path?') ) return;
            this.is_deleting = true;
            try{
                const deletedPath = await API.learning_paths.destroy( this.path.id );
                this.$emit('deleted', deletedPath);
            } catch (e) {}
            this.is_deleting = false;

        },

        close(){
            this.$emit('close');
        }

    },


    mounted() {
        if( Array.isArray( this.path?.meta ) ){
            this.path.meta = {};
        }

        console.log( this.current_tagged_tenant() );

        const tenant = this.current_tagged_tenant();
        this.tenant_id = tenant?.id;

    }

}
</script>

<style scoped>

</style>
